<div class="wccard px-3 py-2 mb-3px">
  <div class="row">
    <div class="col d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0 text-webbtree-green pointer" (click)="handleBackEvent()">
          <i class="fa-regular fa-arrow-left"></i> Back
        </p>
    <div class="ml-2">
  <p class="mb-1 font-weight-600">{{projectDetails?.projectname | titlecase}}</p>
  <p class="m-0 text-9696 f-12">
    <i class="fa-regular fa-flag-pennant mr-1"></i>
    {{projectDetails?.jobtitles[0] | titlecase}}
    <span *ngIf="projectDetails?.jobtitles?.length > 1"
          matTooltip="{{projectDetails?.jobtitles?.slice(1)?.toString()}}"
          [matTooltipClass]="{ 'red-tooltip': true }">
      +{{projectDetails?.jobtitles?.length - 1}}
    </span>
    <i class="fas fa-circle mx-2" style="font-size: 5px;"></i>
    <i class="fa-regular fa-location-dot mr-1"></i>
    <span *ngIf="projectDetails?.locations?.length > 0">
      {{chipCleanUp(projectDetails?.locations[0]) | titlecase}}
      <span *ngIf="projectDetails?.locations?.length > 1"
            matTooltip="{{chipCleanUp(projectDetails?.locations?.slice(1))}}"
            [matTooltipClass]="{ 'red-tooltip': true }">
        +{{projectDetails?.locations?.length - 1}}
      </span>
    </span>
    <span *ngIf="!projectDetails?.locations?.length">
      {{projectDetails?.location | titlecase}}
    </span>
    <span *ngIf="projectDetails?.distance && projectDetails?.distanceunit" class="mr-1">|</span> <span *ngIf="projectDetails?.distance && projectDetails?.distanceunit">Distance: {{projectDetails?.distance}} {{projectDetails?.distanceunit}}</span></p>

</div>


      </div>

      <div>
        <span matTooltip="Rename" matTooltipClass="red-tooltip text-black" class="ml-2 pointer"
          (click)="openRenameProjectModel(projectDetails)">
          <i class="fa-regular fa-ellipsis-vertical"></i>
        </span>
      </div>
    </div>
  </div>
        <!-- <div>
          <span class="text-9696 f-12"><i class="fa-regular fa-flag-pennant mr-1"></i>{{projectDetails?.jobtitles[0] |
            titlecase}}, <span *ngIf="projectDetails?.jobtitles?.length > 1" matTooltip="{{chipCleanUp(projectDetails?.jobtitles?.slice(1)?.toString())}}" [matTooltipClass]="{ 'red-tooltip': true }">+{{projectDetails?.jobtitles?.length - 1}}</span>
            <i class="fas fa-circle mx-2" style="font-size: 5px;"></i><span><i
                class="fa-regular fa-location-dot mr-1"></i>{{projectDetails?.location | titlecase}}</span></span>
        </div> -->
</div>


<!-- For Choose tab -->
<div class="wccard  px-3 py-2  mb-3px">
  <div class="row">
    <div class="col pl-0">
      <span class="f-14 pointer"
        [ngClass]="{ 'tabActive': showProjectDetailsTab, 'tabBtn': !showProjectDetailsTab }"
        (click)="onTabChange('project-tab')">
        Project Details
      </span>
      <span class="f-14 pointer"
        [ngClass]="{ 'tabActive': showEvaluationCriteriaTab, 'tabBtn': !showEvaluationCriteriaTab }"
        (click)="onTabChange('evaluation-tab')">
        Autopilot<sup><span>AI</span></sup> Evaluation Criteria
      </span>
      <span class="f-14 pointer"
        [ngClass]="{ 'tabActive': showActivityTab, 'tabBtn': !showActivityTab}"
        (click)="onTabChange('activity-tab')">
        Activity
      </span>
    </div>
  </div>
</div>


<!-- For Project Details -->
<div class="wccard px-3 py-1 mb-3px" *ngIf="showProjectDetailsTab">
   <div class="row mb-3">
    <div class="col">
      <div class="d-flex align-items-center justify-content-between">
        <span class="f-14 font-weight-600" style="color: #484B59;">Basic Details</span>
        <!-- <div class="p-1" style="background-color: #FFDE251A; opacity: 1;">
          <span class="f-14 font-weight-400" style="color: #969696;">
            <i class="fa-solid fa-circle-info" style="color: #FFED27;"></i>
            The Job Description cannot be modified once the project is created</span>
        </div> -->
        <div class="text-webbtree-green pointer" (click)="editProjects()"
          style="border: 1px solid #2E93A1; padding: 4px 11px 4px 10px;">
          <i class="fa-regular fa-pen-to-square"></i>
          <span class="ml-1">Edit</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Job Title</p>
      <p class="f-14 font-weight-400 text-black mb-0">{{chipCleanUp(projectDetails?.jobtitles) | titlecase}}</p>
    </div>
  </div>
  <div class="row mb-4">
     <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Experience </p>
      <p class="f-14 font-weight-400 text-black mb-0" *ngIf="!projectDetails?.minexperience && !projectDetails?.maxexperience"> - </p>
      <p class="f-14 font-weight-400 text-black mb-0" *ngIf="projectDetails?.minexperience || projectDetails?.maxexperience">{{projectDetails?.minexperience ? projectDetails?.minexperience : 0}} {{projectDetails?.maxexperience ? '-' : ''}} {{projectDetails?.maxexperience ? projectDetails?.maxexperience : '+'}}</p>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Location </p>
      <p class="f-14 font-weight-400 text-black mb-0"><span *ngIf="projectDetails?.locations?.length > 0"> {{ chipCleanUp(projectDetails?.locations) | titlecase}}</span> <span *ngIf="projectDetails?.distance && projectDetails?.distanceunit" class="mr-1 ml-1">|</span>
      <span *ngIf="projectDetails?.distance && projectDetails?.distanceunit">Distance: {{projectDetails?.distance}} {{projectDetails?.distanceunit}}</span></p>
    </div>
    <!-- <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Seniority </p>
      <p class="f-14 font-weight-400 text-black mb-0">{{projectDetails?.seniority ? projectDetails?.seniority: '-'}}</p>
    </div> -->
  </div>
  <div class="row mb-4">
    <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Description </p>
      <p class="f-14 font-weight-400 text-black mb-0" [innerHtml]="projectDescription"></p>

    </div>
  </div>
  <p class="font-weight-600 f-16">Preferences</p>
  <div class="row mb-4">
    <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Target Industry </p>
      <div class="f-14 font-weight-400 text-black mb-0 d-flex flex-wrap" *ngIf="targetIndustries?.length > 0"> <span class="ai-source-chips" *ngFor="let industry of targetIndustries"><span><i [class]="getIndustryIcon(industry)"></i></span> <span>{{industry | titlecase}}</span></span></div>
      <div class="f-14 font-weight-400 text-black mb-0 d-flex flex-wrap" *ngIf="targetIndustries?.length == 0">-</div>
    </div>
  </div>
   <div class="row mb-4">
    <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Skills </p>
      <div class="f-14 font-weight-400 text-black mb-0 d-flex flex-wrap" *ngIf="projectSkills?.length > 0">
        <span class="ai-source-chips" *ngFor="let skill of projectSkills">
          {{chipCleanUp(skill) |titlecase}}</span></div>
      <div class="f-14 font-weight-400 text-black mb-0 d-flex flex-wrap" *ngIf="projectSkills?.length == 0">-</div>
    </div>
  </div>
   <div class="row mb-4">
    <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Target Company</p>
      <div class="f-14 font-weight-400 text-black mb-0 d-flex" *ngIf="targetCompanies?.length > 0">
        <span class="ai-source-chips" *ngFor="let company of targetCompanies"> <span class="companylogo">&nbsp;</span> {{chipCleanUp(company) |titlecase}}</span>
      </div>
      <div class="f-14 font-weight-400 text-black mb-0" *ngIf="targetCompanies?.length == 0">-
      </div>
    </div>
  </div>
     <div class="row mb-4">
    <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Functions </p>
      <div class="f-14 font-weight-400 text-black mb-0 d-flex flex-wrap" *ngIf="functions?.length > 0">
        <span class="ai-source-chips" *ngFor="let fun of functions">
          <span>{{fun | titlecase}}</span>
        </span>
      </div>
      <div class="f-14 font-weight-400 text-black mb-0 d-flex flex-wrap" *ngIf="functions?.length == 0">-</div>
    </div>
  </div>



</div>

<!-- For Evaluation Criteria -->
<div class="wccard px-3 mb-3px" *ngIf="showEvaluationCriteriaTab">
  <div class="row">
    <div class="col">
      <app-evaluation-criteria [tab]="tab" [projectDetails]="projectDetails"></app-evaluation-criteria>
    </div>
  </div>
</div>
<div  *ngIf="showActivityTab">
  <app-ai-sourcing-activity ></app-ai-sourcing-activity>
</div>
<!-- For Rename Project model -->
<ng-template #renameProjectModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="f-14 font-weight-600" id="experience">Rename Project</h5>

      <span class="f-14 font-weight-600"></span>
      <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
    </div>
    <div class="d-flex flex-column w-100 mt-2">
      <input data-testid="auto-app-project-details-input-1" [formControl]="renameProjectInput" placeholder="Enter Project Name" type="text"
        class="wc-form-control nobg">
      <span class="f-12 text-danger mt-1" *ngIf="renameProjectError">Duplicate Tag</span>
      <span class="f-12 text-danger mt-1" *ngIf="renameProjectInputSpecialCharError">Special Character Not
        Allowed</span>
      <span class="f-12 text-danger mt-1" *ngIf="dublicateProjectNameError">Duplicate project name</span>
    </div>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-project-details-button-1" class="btn-trms-small mr-3" [ngClass]="{ 'bg-gray': dublicateProjectNameError, 'text-center': showSpinnerLoader }" (click)="renameProject()"
          [disabled]="showSpinnerLoader || renameProjectInputSpecialCharError || renameProjectError || dublicateProjectNameError">
          <span [ngClass]="{ 'spinner-border text-blue spinner-size': showSpinnerLoader }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showSpinnerLoader }">
            {{showSpinnerLoader ? '' : 'Save'}}
          </span>
        </button>
        <!-- <button data-testid="auto-app-project-details-button-2" class="btn-trms-small" (click)="dismiss()">NO</button> -->
      </div>
    </div>
  </div>
</ng-template>

<!-- For Rename Project model -->
<ng-template #handleBackEventModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <span class="f-14 font-weight-600">Are you sure you want to exit?
      </span>
      <!-- <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span> -->
    </div>
    <div class="d-flex flex-column w-100 mt-2">
      <p class="f-14 ">Unsaved progress will be lost.</p>
    </div>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-project-details-button-3" class="btn-trms-white mr-3" (click)="handleBackEvent()">Confirm</button>
        <button data-testid="auto-app-project-details-button-4" class="btn-trms-small" (click)="dismiss()">Cancel</button>
      </div>
    </div>
  </div>
</ng-template>



<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info"
  (close)="infoMessage = ''">
  <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
  <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>
